<template>

<section class="px-5 py-4 md:py-7 lg:py-10 bg-white my-10 rounded-xl relative overflow-visible grid grid-cols-12 gap-3 h-60">

  <div class="col-span-full md:col-span-3 flex -mt-12 md:mt-0">
    <div class="table m-auto w-max">
      <div class="flex-shrink-0 w-24 h-24 rounded-full overflow-hidden">
        <img class="min-w-full min-h-full relative top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 transition-all select-none z-10" :src="chatRoom.icon" :alt="chatRoom.name">
      </div>
    </div>
  </div>

  <div class="col-span-6 md:col-span-4 flex flex-col space-y-1 justify-center text-purple-600">
    <h6 class="text-lg md:text-xl lg:text-2xl line-clamp-2">
      {{chatRoom.name}}
    </h6>
    <div class="text-sm flex flex-col">
      <h6>{{ chatCreatorUsername }} </h6>
      <h6>{{ memberCount }}  <span class="hidden md:inline">members</span> </h6>

      <div class="flex mt-2">
        <div v-for="member in onBannerChatMember" :key="member.id" class="w-7 md:w-10 h-7 md:h-10 rounded-full overflow-hidden shadow-xl -mr-4 bg-purple-800 z-10">
          <img :src="member.icon" :alt="member.username" class="min-w-full min-h-full relative top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 transition-all select-none z-10">  
        </div>
        <div v-if="chatMemberLeft > 0" class="w-10 h-10 rounded-full overflow-hidden shadow-xl -mr-4 bg-purple-800 z-10 flex">
          <h6 class="text-white table m-auto"> +{{  chatMemberLeft }} </h6>
        </div>
      </div>

    </div>
  </div>

  <div class="col-span-6 md:col-span-5 max-h-40 overflow-auto purple-small-scroll text-xs md:text-sm text-purple-400 break-words ">
    <h6>
      {{chatRoom.description}}
    </h6>
  </div>

  </section>
  
</template>

<script>
export default {
  data(){
    return {
      iconLimit : 3
    }
  },
  props : {
    chatMembers : Object,
    chatRoom : Object
  },
  computed : {
    onBannerChatMember(){
      if(!this.chatMembers)return [];
     
      if(Object.keys(this.chatMembers).length < (this.iconLimit-1) )return this.chatMembers;
      let showMembers = {};
      let count = 0;
      for(var key in this.chatMembers){
        if(count >= this.iconLimit)break;
        showMembers[key] =  this.chatMembers[key];
        count++;
      }
      return showMembers;
    },
    chatMemberLeft(){
      if(!this.chatMembers)return [];
      return Object.keys(this.chatMembers).length - this.iconLimit;
    },
    chatCreatorUsername(){
      if(!this.chatMembers)return "";
      if(!this.chatRoom)return "";
      if(!this.chatMembers[this.chatRoom.creatorId])return "";
      return 'Created by ' + this.chatMembers[this.chatRoom.creatorId].username;
    },
    memberCount(){
      if(!this.chatMembers)return 0;
      return Object.keys(this.chatMembers).length;
    },
  },
}
</script>

<style>

</style>